import api from './api';

const userRoleService = {
  getPracticeStaff: async (practiceId) => {
    const response = await api.get(`/settings/user-roles/practices/${practiceId}/staff`);
    return response;
  },

  changeRole: async (practiceId, userId, roleId) => {
    const response = await api.put(
      `/settings/user-roles/practices/${practiceId}/users/${userId}`,
      { role_id: roleId }
    );
    return response;
  },
};

export default userRoleService;
